var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrRightP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95854 0.240333C7.63777 -0.0803223 7.11768 -0.0802129 6.79702 0.240333C6.47614 0.561208 6.47614 1.08118 6.79713 1.40205L9.95336 4.55812L0.813527 4.559C0.359914 4.55911 -0.00773029 4.92674 -0.0077303 5.38057C-0.0076208 5.83417 0.360023 6.2017 0.813636 6.2017L9.9538 6.20083L6.7968 9.35755C6.47603 9.67832 6.47603 10.1985 6.7968 10.5192C6.95724 10.6795 7.1674 10.7598 7.37767 10.7598C7.58783 10.7598 7.79799 10.6795 7.95843 10.5193L12.5175 5.96044C12.6715 5.80647 12.7581 5.59763 12.7581 5.37969C12.7579 5.16176 12.6714 4.95303 12.5173 4.79873L7.95854 0.240333Z",
    fill: "#29185E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRightP);
export default __webpack_public_path__ + "static/media/arr-right-p.30ae7d3dd256dc18ca344e025966b655.svg";
export { ForwardRef as ReactComponent };